/*
----------------
launchpad/snips
----------------
A <Snip> component is used wherever dynamic text content is to appear.

*/

import {getGlobal, setGlobal, getSnip, setSnip, PageContext} from 'launchpad';
import ContentEditable from 'react-contenteditable';
import React from 'react';
import { Editor } from 'slate-react'
import { Value } from 'slate'
import { html, renderNode, renderMark, hotKeys, setActiveEditor, getActiveEditor,
  getActiveEditorComponent, editorClick, checkActiveBlocks } from './snip_data'
import EditList from 'slate-edit-list'
import styled from 'styled-components'




// const slateEditorPlugins = [ EditList() ]
const slateEditorPlugins = []

export const getPlainText = (html) =>{
  return html.replace(/<[^>]+>/g, '')
}

export class SlateEditor extends React.Component {
  constructor(props){
    super(props)
    this.state = this.defaultState
    this.state.defaultValue = ''
  }

  get defaultState() {
    const props = this.props
    const component = props.inline ? props.component || 'span' : props.component || 'p'
    const lorem = props.default || (getGlobal('is_admin') ? this.props.placeholder : '') || (getGlobal('is_admin') ? getLorem(props.lorem || 3, component) : '')
    return {
      value: html.deserialize(lorem),
      htmlValue: '',
      plainText: ''
    }
  }

  componentDidMount() {
    this.checkValue()
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkValue()
  }

  shouldComponentUpdate(np, ns) {
    if(getGlobal('is_admin') != this.admin){
      this.admin = getGlobal('is_admin')
      //if(!this.state.htmlValue && !this.props.defaultValue) this.setState(this.defaultState)
      return true
    }
    const s = this.state
    const p = this.props
    return (
      s.value != ns.value
      || p.defaultValue != np.defaultValue
      || s.defaultValue != ns.defaultValue
    )
  }

  checkValue = () => {
    const v = this.props.defaultValue
    if(v && !this.state.defaultValue) {
      const value = getPlainText(v).replace(/ /g, '') ? html.deserialize(v) : this.defaultState.value
      this.setState({ defaultValue: v, value, plainText: getPlainText(v) })
    }
    this.resetContent()
  }

  onChange = ({value}) => {
    this.setState({ value })
    if(!this.state.plainText){
      this.setState({plainText: 'active'})
    }
    if(this.debounceTimer){
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      //this.pushChange(v)
      const htmlValue = html.serialize(value)
      const plainText = getPlainText(htmlValue).replace(/ /g, '')
      this.setState({ htmlValue, plainText })
      if(this.props.onChange) this.props.onChange(htmlValue)
    }, 300);
  }

  resetContent = () => {
    setTimeout(() => {
      if(!this.focused) {
        const text = getPlainText(html.serialize(this.state.value)).replace(/ /g, '')
        if(!text.length) this.setState(Object.assign({empty: true} , this.defaultState))
      }
    }, 100)
  }

  focus = (e, editor) => {
    this.focused = true
    if(!this.state.plainText){
      const props = this.props
      const component = props.inline ? props.component || 'span' : props.component || 'p'
      const lorem = getLorem(0, component)
      this.setState({value: html.deserialize(lorem)}, ()=>setTimeout(editor.focus, 0))
    }
    setActiveEditor(editor, this)
  }

  blur = (e, editor) => {
    this.focused = false
    setTimeout(() => {
      if(!this.focused && getActiveEditorComponent() != this) {
        setActiveEditor(null)
      }
    }, 100)
    this.resetContent()
  }

  render = () => {
    const props = getGlobal('is_admin') ? {
      onChange: this.onChange,
      onClick: (e, editor) => {
        if(!this.props.allowClick){
            e.stopPropagation()
            e.preventDefault()
        }
        editorClick(e, editor)
        //editor.focus()
      },
      onKeyDown: hotKeys,
      onKeyUp: (e, editor) => checkActiveBlocks(editor),
      onFocus: this.focus,
      onBlur: this.blur,
      onFocusIn: this.focus,
    } : {
      readOnly: true,
      onClick: () => {}
    }

    return <Editor
      {... props}
      className={`${this.props.className} ${!this.state.plainText ? 'empty' : ''}`}
      value={this.state.value}
      plugins={slateEditorPlugins}
      renderNode={renderNode}
      renderMark={renderMark}
    />
  }
}


class SnipClass extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      initialized: false,
      htmlValue: '',
      snip: {}
    }
  }

  pushChange = (v) => {
    if(v != this.state.htmlValue) {
      this.setState({htmlValue: v})
      // TODO: sync with other snips that have the same name/page
      setSnip(v, null, this.props.name, this.props.page)
    }
  }

  render() {
    const { name, page, inline, className } = this.props
    const snip = getSnip(this.props.name, this.props.page);
    const plain = getPlainText((snip && snip.content) || '')
    const cn = `${className ? className : ''} snip-container ${inline ? 'inline' : ''} ${getGlobal('is_admin') ? 'admin' : ''}`
    const C = this.props.component || 'div'
    return <SlateEditor
      onClick={e => e.stopPropagation()} {...this.props}
      defaultValue={snip && snip.content}
      onChange={this.pushChange}
      className={cn}
    />

    return getGlobal('is_admin')
      ? <SlateEditor
        onClick={e => e.stopPropagation()} {...this.props}
        defaultValue={snip && snip.content}
        onChange={this.pushChange}
        className={cn}
      />
      : <C className={cn} dangerouslySetInnerHTML={{__html: (snip && plain && snip.content) || this.state.htmlValue ||  this.props.default || ''}} />
  }
}

export const Snip = (props) => <PageContext.Consumer>
  { context => <SnipClass {...props} page={props.page || context.pageId} /> }
</PageContext.Consumer>



export const getLorem = (length, component) => {
  const c = component || 'p'
  const l= (lorem.split(' ').slice(0, length)).join(' ') + (length ? '...' : '')
  if(!component) return l
  return `<${c}>${l.split(/[\r\n]+/).filter(t => t ? true : false).join(`</${c}><${c}>`)}</${c}>`
}

// alias SlateEditor for backwards compatibility
export const TextEditor = (props) => {
  return getGlobal('is_admin')
    ? <SlateEditor {...props} defaultValue={props.value} />
    : <div dangerouslySetInnerHTML={{__html: props.value}} />
}


const lorem = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris. Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla.

Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur sodales ligula in libero. Sed dignissim lacinia nunc. Curabitur tortor. Pellentesque nibh. Aenean quam. In scelerisque sem at dolor. Maecenas mattis. Sed convallis tristique sem. Proin ut ligula vel nunc egestas porttitor. Morbi lectus risus, iaculis vel, suscipit quis, luctus non, massa. Fusce ac turpis quis ligula lacinia aliquet. Mauris ipsum.

Nulla metus metus, ullamcorper vel, tincidunt sed, euismod in, nibh. Quisque volutpat condimentum velit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nam nec ante. Sed lacinia, urna non tincidunt mattis, tortor neque adipiscing diam, a cursus ipsum ante quis turpis. Nulla facilisi. Ut fringilla. Suspendisse potenti. Nunc feugiat mi a tellus consequat imperdiet. Vestibulum sapien. Proin quam. Etiam ultrices. Suspendisse in justo eu magna luctus suscipit. Sed lectus.

Integer euismod lacus luctus magna. Quisque cursus, metus vitae pharetra auctor, sem massa mattis sem, at interdum magna augue eget diam. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Morbi lacinia molestie dui. Praesent blandit dolor. Sed non quam. In vel mi sit amet augue congue elementum. Morbi in ipsum sit amet pede facilisis laoreet. Donec lacus nunc, viverra nec, blandit vel, egestas et, augue. Vestibulum tincidunt malesuada tellus. Ut ultrices ultrices enim. Curabitur sit amet mauris. Morbi in dui quis est pulvinar ullamcorper. Nulla facilisi.

Integer lacinia sollicitudin massa. Cras metus. Sed aliquet risus a tortor. Integer id quam. Morbi mi. Quisque nisl felis, venenatis tristique, dignissim in, ultrices sit amet, augue. Proin sodales libero eget ante. Nulla quam. Aenean laoreet. Vestibulum nisi lectus, commodo ac, facilisis ac, ultricies eu, pede. Ut orci risus, accumsan porttitor, cursus quis, aliquet eget, justo.

Sed pretium blandit orci. Ut eu diam at pede suscipit sodales. Aenean lectus elit, fermentum non, convallis id, sagittis at, neque. Nullam mauris orci, aliquet et, iaculis et, viverra vitae, ligula. Nulla ut felis in purus aliquam imperdiet. Maecenas aliquet mollis lectus. Vivamus consectetuer risus et tortor. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi.

Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris. Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur sodales ligula in libero. Sed dignissim lacinia nunc. Curabitur tortor. Pellentesque nibh. Aenean quam.

In scelerisque sem at dolor. Maecenas mattis. Sed convallis tristique sem. Proin ut ligula vel nunc egestas porttitor. Morbi lectus risus, iaculis vel, suscipit quis, luctus non, massa. Fusce ac turpis quis ligula lacinia aliquet. Mauris ipsum. Nulla metus metus, ullamcorper vel, tincidunt sed, euismod in, nibh. Quisque volutpat condimentum velit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nam nec ante.

Sed lacinia, urna non tincidunt mattis, tortor neque adipiscing diam, a cursus ipsum ante quis turpis. Nulla facilisi. Ut fringilla. Suspendisse potenti. Nunc feugiat mi a tellus consequat imperdiet. Vestibulum sapien. Proin quam. Etiam ultrices. Suspendisse in justo eu magna luctus suscipit. Sed lectus. Integer euismod lacus luctus magna. Quisque cursus, metus vitae pharetra auctor, sem massa mattis sem, at interdum magna augue eget diam.

Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Morbi lacinia molestie dui. Praesent blandit dolor. Sed non quam. In vel mi sit amet augue congue elementum. Morbi in ipsum sit amet pede facilisis laoreet. Donec lacus nunc, viverra nec, blandit vel, egestas et, augue. Vestibulum tincidunt malesuada tellus. Ut ultrices ultrices enim. Curabitur sit amet mauris. Morbi in dui quis est pulvinar ullamcorper. Nulla facilisi. Integer lacinia sollicitudin massa. Cras metus. Sed aliquet risus a tortor.
`;
